import { PipeTransform } from '@angular/core';
var FirstNamePipe = /** @class */ (function () {
    function FirstNamePipe() {
    }
    FirstNamePipe.prototype.transform = function (value) {
        return (value || '').replace(/ .*$/, '');
    };
    return FirstNamePipe;
}());
export { FirstNamePipe };
